import { render, staticRenderFns } from "./ktabspanel.vue?vue&type=template&id=14867010&scoped=true"
import script from "./ktabspanel.vue?vue&type=script&lang=js"
export * from "./ktabspanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14867010",
  null
  
)

export default component.exports